export default "__VITE_PUBLIC_ASSET__6c6ace6e__"